const WORDS = ["Edukacja", "Wsparcie", "Spektrum Autyzmu", "Materiały do druku", "E-booki", "Kursy"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section className="py-10 border-y border-ink/5 bg-white/50 overflow-hidden">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-600 text-3xl sm:text-4xl text-ink/80 px-8">{w}</span>
            <span className="h-2.5 w-2.5 rounded-full bg-violet" />
          </span>
        ))}
      </div>
    </section>
  );
};
